import * as React from 'react'
import * as Styles from './styles'
import * as Types from './types'

// TODO - we currently have 2 tooltips - neither is very reusable.
//  This one should probably lay the ground to replace `src/components/Tooltip`
//  but needs a bit more work, as it's tightly coupled to this context.
const Tooltip: React.FunctionComponent<Types.Tooltip> = ({
  children,
  onClick,
  point,
  className,
}) => {
  return (
    <Styles.Border onClick={onClick} className={className}>
      <Styles.Text>{children}</Styles.Text>
      {/* 
        Adding a second arrow is a necessary evil to add border to a css triangle
        https://stackoverflow.com/questions/9450733/css-triangle-custom-border-color
    */}
      <Styles.BorderArrow point={point} />
      <Styles.Arrow point={point} />
    </Styles.Border>
  )
}
export default Tooltip



// WEBPACK FOOTER //
// ./src/layouts/shared/Recheck/Tooltip/index.tsx